import { executiveStatuses } from './dashboard.data';

export const ExecutiveStatusPanel = () => (
  <section
    className="arx-executive-panel"
    aria-labelledby="arx-dashboard-status-title"
  >
    <div className="arx-executive-panel__header">
      <div>
        <span>PLATAFORMA</span>
        <h2 id="arx-dashboard-status-title">Estado dos serviços</h2>
      </div>
      <span className="arx-executive-panel__badge">Atualização estrutural</span>
    </div>

    <div className="arx-executive-status-list">
      {executiveStatuses.map(item => (
        <article className="arx-executive-status" key={item.id}>
          <span
            className={`arx-executive-status__indicator arx-executive-status__indicator--${item.tone}`}
            aria-hidden="true"
          />
          <div>
            <strong>{item.label}</strong>
            <p>{item.detail}</p>
          </div>
          <span>{item.value}</span>
        </article>
      ))}
    </div>
  </section>
);
